import {
  OptionsContainer,
  AdvancedOptionsLink,
  ArrowContainer,
} from 'components/Panel/PanelStyles';
import { Dispatch, ReactNode } from 'react';
import { ChevronUp, ChevronDown } from 'react-bootstrap-icons';

type Property = {
  expand: boolean;
  setExpand: Dispatch<React.SetStateAction<boolean>>;
  label?: string;
  children?: ReactNode;
};

/**
 * Create a collapsible div to dynamically show/hide child components.
 * @param properties
 * @returns
 */
export const Collapsible = (properties: Property) => {
  const { expand, setExpand, label, children } = properties;

  const renderArrow = () => (
    <ArrowContainer>
      {expand ? (
        <ChevronUp size={'10px'} fill='#BCBCBC' />
      ) : (
        <ChevronDown size={'10px'} fill={'#BCBCBC'} />
      )}
    </ArrowContainer>
  );

  return (
    <OptionsContainer>
      <AdvancedOptionsLink
        href='#'
        onClick={() => {
          setExpand(!expand);
        }}
      >
        {label || (expand ? 'Collapse' : 'Expand')} {renderArrow()}
      </AdvancedOptionsLink>
      {expand && <OptionsContainer>{children}</OptionsContainer>}
    </OptionsContainer>
  );
};
